module.exports = __webpack_public_path__ + "img/intro_icon.94cc4c0d.svg";